import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaChevronLeft, FaChevronRight, FaCalendarWeek } from "react-icons/fa";
import { homeDentalProcedure } from "../../secondUtils/constants";

function ImageSlider(props) {
    const [isVisible, setIsVisible] = useState(false);
    const [currentSlide, setCurrentSlide] = useState(0);
    const { selectedLanguage, language } = props
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 2000);
        return () => clearTimeout(timer);
    }, []);

    const CustomNextArrow = ({ onClick }) => (
        <div className="second-design-custom-arrow second-design-next" onClick={() => { onClick(); setIsVisible(false); }}>
            <FaChevronRight />
        </div>
    );

    const CustomPrevArrow = ({ onClick }) => (
        <div className="second-design-custom-arrow second-design-prev" onClick={() => { onClick(); setIsVisible(false); }}>
            <FaChevronLeft />
        </div>
    );

    const handleSlideChange = (current) => {
        setCurrentSlide(current);
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 2000);
        return () => clearTimeout(timer);
    };

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />,
        afterChange: handleSlideChange
    };

    return (
        <div className="slider-container">
            <Slider {...settings}>
                <div className="slide-item home_slider_1">
                    <div className="home_slider_text_div_main">
                        <div className="home_slider_text_div">
                            <h2 data-aos="fade"
                                data-aos-easing="ease-out-bounce"
                                data-aos-delay="100"
                                data-aos-duration="1000">
                                {selectedLanguage?.txt_make_your}
                                <span className="heading_span"> {selectedLanguage?.txt_dental}</span>
                            </h2>
                            <h2 data-aos="fade"
                                data-aos-easing="ease-out-bounce"
                                data-aos-delay="200"
                                data-aos-duration="2000">{selectedLanguage?.txt_experience_a_lot_brighter}</h2>
                            <p data-aos="fade-down"
                                data-aos-easing="ease-out-bounce"
                                data-aos-delay="100"
                                data-aos-duration="1000">{selectedLanguage?.txt_with_best_facilities}</p>
                            <button className="constant_btn consult_btn">{selectedLanguage?.txt_consult_a_dentist}</button>
                            <button className="constant_btn appointment_btn">{selectedLanguage?.txt_make_an_appointment}</button>
                        </div>
                    </div>
                    {/* {isVisible ? <div className="slider-img-text" data-aos="fade-down"
                        data-aos-easing="ease-out-bounce"
                        data-aos-delay="200"
                        data-aos-duration="1000">
                        <p className="text-1">{selectedLanguage?.txt_treat_your_teeth}</p>
                        <p className="text-2">VISIT EGYPT</p>
                    </div> : null} */}
                </div>
                <div className="slide-item home_slider_2">
                    <div className="home_slider_text_div_main">
                        <div className="home_slider_text_div">
                            <h2 data-aos="fade"
                                data-aos-easing="ease-out-bounce"
                                data-aos-delay="100"
                                data-aos-duration="1000">
                                {selectedLanguage?.txt_expertise_in_major}
                            </h2>
                            <h3 data-aos="fade"
                                data-aos-easing="ease-out-bounce"
                                data-aos-delay="200"
                                data-aos-duration="2000">{selectedLanguage?.txt_dental_procedures}</h3>
                            {
                                homeDentalProcedure?.map((v, i) => {
                                    return (
                                        <div className="home_dental_procedure_div">
                                            <img src={v?.img} alt="" />
                                            <p>
                                                {isELSelect ? v?.name : (isAlSelect ? v?.alName : v?.glName)}
                                            </p>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                    {/* <img src={slide_2} alt="img" /> */}
                    {/* {isVisible ? <div className="slider-img-right-text" data-aos="fade-down"
                        data-aos-easing="ease-out-bounce"
                        data-aos-delay="200"
                        data-aos-duration="1000">
                        <p className="text-1">{selectedLanguage?.txt_treat_your_teeth}</p>
                        <div className="img-2-text"><p className="text-2">VISIT EGYPT</p></div>
                    </div> : null} */}
                </div>
                <div className="slide-item home_slider_3">
                    <div className="home_slider_text_div_main home_slider_text_div3_main">
                        <div className="home_slider_text_div">
                            <h2>
                                {selectedLanguage?.txt_from_simple}
                                <span className="heading_span"> {selectedLanguage?.txt_procedures}</span>
                                <br />
                                {selectedLanguage?.txt_to_complex}
                                <span> {selectedLanguage?.txt_surgeries}</span>
                            </h2>
                            {/* <h2>Experience a Lot Brighter</h2> */}
                            <p>{selectedLanguage?.txt_with_best_facilities}</p>
                            <button className="constant_btn consult_btn">{selectedLanguage?.txt_consult_a_dentist}</button>
                            <button className="constant_btn appointment_btn">{selectedLanguage?.txt_make_an_appointment}</button>
                            <button className="callUs_btn">{selectedLanguage?.txt_call_us}</button>
                            <h2>+991 3334 3347 <span className="tool_free_span">({selectedLanguage?.txt_tool_free})</span></h2>
                        </div>
                    </div>
                    {/* <img src={slide_3} alt="img" /> */}
                    {/* {isVisible ? <div className="slider-img-right-text" data-aos="fade-down"
                        data-aos-easing="ease-out-bounce"
                        data-aos-delay="200"
                        data-aos-duration="1000">
                        <p className="text-1">{selectedLanguage?.txt_treat_your_teeth}</p>
                        <div className="img-2-text"><p className="text-2">VISIT EGYPT</p></div>
                    </div> : null} */}
                </div>
            </Slider>
            <div className="slider_footer"
                data-aos="fade-up"
                data-aos-easing="ease-out-bounce"
                data-aos-delay="200"
                data-aos-duration="1000">
                <h2 className="slider_footer_text">{selectedLanguage?.txt_get_in_touch_with_us_today}
                    <span className="slider_footer_text_span"> {'(02) 9955 4239'}</span>
                </h2>
                <div className="slider_footer_btn_div">
                    <button className="slider_footer_btn_div_btn">{selectedLanguage?.txt_make_an_appointment}</button>
                    <button className="slider_footer_btn_div_icon_btn">
                        <FaCalendarWeek />
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ImageSlider;
